<template>
  <div>
    <fade-down-modal :show="showOrHide">
      <div class="registeredSubAccount comMsgbox">
        <div class="header">
          <header-tag :title="headerTitle"></header-tag>
        </div>
        <div class="content">
          <div class="name commonStyle">
            <span>姓名：</span>
            <input
              type="text"
              placeholder="请填写使用者姓名"
              v-model="list.name"
            />
          </div>
          <div class="loginAccount commonStyle">
            <span>登录账号：</span>
            <input
              type="text"
              placeholder="长度6-16位数字、英文、'-'、'_'均可"
              v-model="list.accountNum"
              :disabled="headerTitle == '修改' ? true : false"
            />
          </div>
          <div class="loginPassword commonStyle">
            <span>登录密码：</span>
            <input
              type="password"
              placeholder="长度6-16位数字、英文大小写、符号任意两种以上组合"
              v-model="list.loginPassword"
            />
          </div>
          <div class="phone commonStyle">
            <span>联系手机：</span>
            <input
              type="text"
              placeholder="填写手机号码"
              v-model="list.phoneNum"
            />
          </div>
          <div class="email commonStyle">
            <span>邮箱：</span>
            <input
              type="email"
              placeholder="填写邮箱地址"
              v-model="list.eMail"
            />
          </div>
          <div class="accountRole commonStyle">
            <span>账号角色：</span>
            <select
              name="accountRole"
              id="accountRole"
              v-model="list.role"
              :disabled="headerTitle == '修改' ? true : false"
              @change="changeType"
            >
              <option
                :value="item.id"
                v-for="item in list.accountRole"
                :key="item.id"
                v-text="item.name"
              ></option>
            </select>
          </div>
          <div class="manageAuthority">
            <span class="title">管理权限：</span>
            <div class="item">
              <ul>
                <li
                  v-for="(item, index) in manageAuthorityList"
                  :key="index"
                  :style="{
                                        display:
                                            (list.role == 3 &&
                                                item.name == '远程控制') ||
                                            list.role == 2
                                                ? 'block'
                                                : 'none'
                                    }"
                >
                  <input
                    type="checkbox"
                    v-model="item.select"
                    @change="
                                            selectValChange(manageAuthorityList)
                                        "
                    :disabled="
                                            list.role == 3 ? true : false
                                        "
                  />
                  <span v-text="item.name"></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="manageDomain">
            <span class="title">管理范围：</span>
            <div class="content">
              <div class="search">
                <div class="left">
                  <input
                    type="text"
                    placeholder="搜索分组名"
                    v-model="groupName"
                    @keyup.enter="searchGroupName"
                    @blur="searchGroupName"
                    v-if="list.role == 2"
                  />
                  <input
                    type="text"
                    placeholder="搜索网吧名"
                    v-model="barName"
                    @keyup.enter="searchBarName"
                    @blur="searchBarName"
                    v-if="list.role == 3"
                  />
                </div>
                <div
                  class="right"
                  v-if="list.role == 2"
                >
                  <input
                    type="checkbox"
                    v-model="checkGroupAll"
                    @change="
                                            checkAll(
                                                checkGroupAll,
                                                manageDomainGroupList
                                            )
                                        "
                  />全选
                </div>
                <div
                  class="right"
                  v-if="list.role == 3"
                >
                  <input
                    type="checkbox"
                    v-model="checkBarAll"
                    @change="
                                            checkAll(
                                                checkBarAll,
                                                manageDomainBarList
                                            )
                                        "
                  />全选
                </div>
              </div>
              <div
                class="group"
                v-if="list.role == 2"
              >
                <ul>
                  <li
                    v-for="(item,
                                        index) in manageDomainGroupList"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      v-model="item.select"
                      @change="
                                                manageDomainChange(
                                                    item.select,
                                                    manageDomainGroupList
                                                )
                                            "
                    />
                    <span v-text="item.groupName"></span>
                  </li>
                </ul>
              </div>
              <div
                class="group"
                v-if="list.role == 3"
              >
                <ul>
                  <li
                    v-for="(item,
                                        index) in manageDomainBarList"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      v-model="item.select"
                      @change="
                                                manageDomainChange(
                                                    item.select,
                                                    manageDomainBarList
                                                )
                                            "
                    />
                    <span v-text="item.barName"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div><img
            src="@/assets/img/icon/u207.png"
            alt=""
          /></div>
        <div class="btn">
          <div class="left">
            <div
              class="wrong"
              v-text="wrongMsg"
              ref="wrongMsg"
            ></div>
          </div>
          <div class="right">
            <a
              href="#"
              class="blue-btn"
              @click.prevent="registerAdd()"
              v-if="headerTitle == '注册子账号'"
            >注册</a>
            <a
              href="#"
              class="blue-btn"
              @click.prevent="conserve()"
              v-if="headerTitle == '修改'"
            >保存</a>
            <a
              href="#"
              class="default-btn"
              @click.prevent="_cancel()"
            >取消</a>
          </div>
        </div>
      </div>
    </fade-down-modal>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from "_c/tagTitle/headerTag";
import FadeDownModal from "_c/modals/fadeDown";
import { mapState, mapActions } from "vuex";
import {
  _searchGroupName,
  _searchBarName,
  registeredSubAccount,
  Edit
} from "@/requests/emplyee";
import httpApi from "@/apis/httpApi";

export default {
  name: "emplyeeModals",
  components: {
    FadeDownModal,
    HeaderTag
  },
  props: {
    currentPage: Number
  },
  data() {
    return {
      checkGroupAll: false,
      checkBarAll: false,
      list: {
        name: "",
        accountNum: "",
        loginPassword: "",
        phoneNum: "",
        eMail: "",
        role: "",
        passportState: "",
        accountRole: [
          {
            id: 2,
            name: "员工"
          },
          {
            id: 3,
            name: "业主"
          }
        ],
        authority: "",
        manageAuthorityList: [],
        manageAuthority: [
          { name: "远程控制" },
          { name: "注册网吧ID" },
          { name: "监控中心" },
          { name: "修改网吧资料" }
        ],
        managementDomain: "",
        manageDomain_group: [],
        manageDomain_bar: []
      },
      groupName: "",
      barName: "",
      wrongMsg: ""
    };
  },
  created() {
    this.$nextTick(() => {
      this.searchGroupName();
      this.searchBarName();
    });
  },
  computed: {
    ...mapState({
      showOrHide: state => state.emplyee.showOrHide,
      headerTitle: state => state.emplyee.title,
      checkList: state => state.emplyee.checkList
    }),
    manageAuthorityList() {
      this.list.manageAuthority.forEach(item => {
        item.select = false;
        if (
          item.name == "远程控制" &&
          this.headerTitle == "注册子账号"
        ) {
          item.select = true;
        }
        return item;
      });
      return this.list.manageAuthority;
    },
    manageDomainGroupList() {
      return this.addSelect(this.list.manageDomain_group);
    },
    manageDomainBarList() {
      return this.addSelect(this.list.manageDomain_bar);
    }
  },
  watch: {
    headerTitle() {
      if (this.headerTitle == "注册子账号") {
        this.empty();
      } else if (this.headerTitle == "修改") {
        this.wrongMsg = "";
        this.addOrEdit(this.checkList);
      }
    },
    checkList() {
      this.addOrEdit(this.checkList);
    },
    currentPage() {
      this.$emit("registerSubAccount", this.currentPage);
    }
  },
  mounted() {
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self._cancel();
        }
      })
    })
  },
  methods: {
    ...mapActions([
      "emplyee/actionSetShowOrHide",
      "emplyee/actionSetTitle",
      "emplyee/actionSetCheckList",
      "emplyee/actionSetActive"
    ]),
    //数组添加select参数
    addSelect(_arr) {
      let arr = [];
      arr = _arr.map(item => {
        item.select = false;
        return item;
      });
      return arr;
    },
    b(arr, arr2, val) {
      for (let x = 0; x < arr2.length; x++) {
        //初始化管理权限复选框、管理范围复选框和全选框的值
        arr2[x].select = false;
        this.checkGroupAll = false;
        this.checkBarAll = false;
        //传过来的数据和原始数据作对比,管理范围中角色为员工的返回分组名数组，角色为业主的返回网吧名数组
        for (let y = 0; y < arr.length; y++) {
          if (val == "员工") {
            if (arr[y].groupName) {
              if (arr[y].groupName == arr2[x].groupName) {
                arr2[x].select = true;
                this.manageDomainChange(arr2[x].select, arr2);
              }
            }
          } else if (val == "业主") {
            if (arr[y].barName) {
              if (arr[y].barName == arr2[x].barName) {
                arr2[x].select = true;
                this.manageDomainChange(arr2[x].select, arr2);
              }
            }
          } else {
            //管理权限
            if (arr[y].permValue) {
              if (
                arr[y].permValue
                  .toString()
                  .indexOf(arr2[x].name) != -1
              ) {
                arr2[x].select = true;
              }
            }
          }
        }
      }
    },
    //修改弹窗传过来的数据
    addOrEdit(arr) {
      this.list.accountNum = arr.passportName;
      this.list.name = arr.personalName;
      this.list.phoneNum = arr.passportPhone;
      this.list.eMail = arr.passportMail;
      this.list.role = arr.passportType;
      this.list.loginPassword = "";
      this.list.passportState = arr.passportState;
      this.b(arr.passportPermissionList, this.manageAuthorityList);
      if (arr.passportType == "员工") {
        this.b(
          arr.barGroupPermissionList,
          this.manageDomainGroupList,
          "员工"
        );
      } else if (arr.passportType == "业主") {
        this.b(
          arr.barGroupPermissionList,
          this.manageDomainBarList,
          "业主"
        );
      }
      for (let i = 0; i < this.list.accountRole.length; i++) {
        if (this.list.role == this.list.accountRole[i].name) {
          this.list.role = this.list.accountRole[i].id;
        }
      }
    },
    //清空所有数据
    empty() {
      this.wrongMsg = "";
      this.list.accountNum = "";
      this.list.name = "";
      this.list.phoneNum = "";
      this.list.eMail = "";
      this.list.role = this.list.accountRole[0].id;
      this.list.loginPassword = "";
      this.checkGroupAll = false;
      this.checkBarAll = false;
      this.list.authority = "";
      this.list.managementDomain = "";
      this.groupName = "";
      this.barName = "";
      this.manageAuthorityList.forEach(item => {
        item.select = false;
        if (
          item.name == "远程控制" &&
          this.headerTitle == "注册子账号"
        ) {
          item.select = true;
        }
      });
      this.selectArr(this.manageDomainGroupList);
      this.selectArr(this.manageDomainBarList);
    },
    //初始化管理范围中input
    selectArr(arr) {
      arr.forEach(item => {
        if (item.select) {
          item.select = false;
        }
      });
    },
    //报错功能
    setWrongMsg(txt) {
      this.wrongMsg = txt;
      this.$domFn.shake(this.$refs.wrongMsg);
    },
    authorityVal(val) {
      let x = 0,
        z = "注册网吧ID",
        z1 = "修改网吧资料";
      if (val.indexOf(z) != -1 && val.indexOf(z1) != -1) {
        x = 3;
      } else if (val.indexOf(z) != -1) {
        x = 1;
      } else if (val.indexOf(z1) != -1) {
        x = 2;
      }
      return x;
    },
    authorityVal1(val) {
      let y = 0,
        m = "远程控制",
        m1 = "监控中心";
      if (val.indexOf(m) != -1 && val.indexOf(m1) != -1) {
        y = 3;
      } else if (val.indexOf(m) != -1) {
        y = 1;
      } else if (val.indexOf(m1) != -1) {
        y = 2;
      }
      return y;
    },
    //账号角色
    changeType() {
      if (this.list.role == 2) {
        this.list.manageDomain_bar.forEach(item => {
          item.select = false;
          return item;
        });
        this.checkBarAll = false;
      } else {
        this.list.manageDomain_group.forEach(item => {
          item.select = false;
          return item;
        });
        this.checkGroupAll = false;
      }
    },
    //注册子账号
    async registerAdd() {
      //校验姓名、账号、密码等
      let vdt = this.$validateCenter.name(this.list.name);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      vdt = this.$validateCenter.loginAccount(this.list.accountNum);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      vdt = this.$validateCenter.passwordWhds(this.list.loginPassword);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      vdt = this.$validateCenter.phoneNum(this.list.phoneNum);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      vdt = this.$validateCenter.email(this.list.eMail);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      let groupList = [],
        barList = [],
        authorityList = [];
      if (this.list.role == 2) {
        this.manageAuthorityList.forEach(item => {
          if (item.select) {
            authorityList.push(item.name);
          }
        });
      } else {
        authorityList = ["远程控制"];
      }
      this.list.manageDomain_group.forEach(item => {
        if (item.select) {
          groupList.push(item.groupId);
        }
      });
      this.list.manageDomain_bar.forEach(item => {
        if (item.select) {
          barList.push(item.barId);
        }
      });
      let obj = {
        name: this.list.name,
        passportName: this.list.accountNum,
        password: encodeURIComponent(this.list.loginPassword),
        phone: this.list.phoneNum,
        email: this.list.eMail,
        passportState: 0,
        passportType: this.list.role,
        pms1: this.authorityVal(authorityList.toString()),
        pms10000: this.authorityVal1(authorityList.toString()),
        groupId: groupList.toString(),
        barId: barList.toString(),
        smsCode: ""
      };
      let res = await registeredSubAccount(obj);
      if (res.code == 200) {
        this["emplyee/actionSetShowOrHide"](false);
        this.empty();
        this["emplyee/actionSetActive"](1);
        this.$emit("registerSubAccount", this.currentPage);
      } else if (res.code == 401) {
        let data = {
          url: httpApi.emplyee.registerAdd,
          data: obj
        };
        let res = await window.$sms.show(data);
        if (res) {
          this["emplyee/actionSetActive"](1);
          this.$emit("registerSubAccount", this.currentPage);
          this["emplyee/actionSetShowOrHide"](false);
        }
        // this.setWrongMsg(res.msg);
      } else {
        this.setWrongMsg(res.msg);
      }
    },
    //保存
    async conserve() {
      //校验姓名、密码等
      let vdt = this.$validateCenter.name(this.list.name);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      vdt = this.$validateCenter.loginAccount(this.list.accountNum);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      if (this.list.loginPassword) {
        vdt = this.$validateCenter.passwordWhds(
          this.list.loginPassword
        );
        if (!vdt.res) {
          this.setWrongMsg(vdt.msg);
          return false;
        }
      }
      vdt = this.$validateCenter.phoneNum(this.list.phoneNum);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      vdt = this.$validateCenter.email(this.list.eMail);
      if (!vdt.res) {
        this.setWrongMsg(vdt.msg);
        return false;
      }
      let groupList = [],
        barList = [],
        authorityList = [];
      this.manageAuthorityList.forEach(item => {
        if (item.select) {
          authorityList.push(item.name);
        }
      });
      this.list.manageDomain_group.forEach(item => {
        if (item.select) {
          groupList.push(item.groupId);
        }
      });
      this.list.manageDomain_bar.forEach(item => {
        if (item.select) {
          barList.push(item.barId);
        }
      });
      let obj = {
        name: this.list.name,
        passportName: this.list.accountNum,
        password: encodeURIComponent(this.list.loginPassword),
        phone: this.list.phoneNum,
        email: this.list.eMail,
        passportState: this.list.passportState,
        pms1: this.authorityVal(authorityList.toString()),
        pms10000: this.authorityVal1(authorityList.toString()),
        groupId: groupList.toString(),
        barId: barList.toString(),
        smsCode: ""
      };
      let res = await Edit(obj);
      if (res.code == 200) {
        //this.smsError='';
        //this.smsshow=false;
        this["emplyee/actionSetShowOrHide"](false);
        this.empty();
        this["emplyee/actionSetActive"](1);
        this.$emit("registerSubAccount", this.currentPage);
      } else if (res.code == 401) {
        let data = {
          url: httpApi.emplyee.edit,
          data: obj
        };
        let res = await window.$sms.show(data);
        if (res) {
          this["emplyee/actionSetActive"](1);
          this["emplyee/actionSetShowOrHide"](false);
        }
      } else {
        // if(this.smsshow){
        //     this.smsError=res.msg;
        //     this.setWrongMsg('')
        // }else{
        this.setWrongMsg(res.msg);
        //}
      }
    },
    //取消功能
    _cancel() {
      if (this.headerTitle == "注册子账号") {
        this["emplyee/actionSetShowOrHide"](false);
        //this.smsshow=false;
        this.empty();
      } else if (this.headerTitle == "修改") {
        this.addOrEdit(this.checkList);
        this["emplyee/actionSetShowOrHide"](false);
        //this.smsshow=false;
      }
    },
    manageDomainChange(checkState, arr) {
      if (checkState) {
        // 对单项进行选中
        // 判断是否全部选中
        let checkAllState = arr.every(item => {
          return item.select == true;
        });
        // 若全部选中,则为全选状态
        if (checkAllState) {
          this.checkGroupAll = true;
          this.checkBarAll = true;
        }
      } else {
        // 对单项进行取消
        if (arr == this.manageDomainGroupList) {
          this.checkGroupAll = false;
        } else {
          this.checkBarAll = false;
        }
      }
      if (arr == this.manageDomainGroupList) {
        this.selectValChange(this.manageDomainGroupList);
      } else {
        this.selectValChange(this.manageDomainBarList);
      }
    },
    //管理权限中input框功能
    selectValChange(listArr) {
      let arr = [];
      listArr.forEach(item => {
        if (item.select == true) {
          if (item.groupName) {
            arr.push(item.groupName);
          } else if (item.barName) {
            arr.push(item.barName);
          }
        }
      });
      if (listArr == this.manageAuthorityList) {
        this.list.authority = arr.toString();
      } else {
        this.list.managementDomain = arr.toString();
      }
    },
    //管理范围全选功能
    checkAll(val, arr) {
      if (val) {
        arr.forEach(item => {
          item.select = true;
        });
      } else {
        arr.forEach(item => {
          item.select = false;
        });
      }
      this.selectValChange(arr);
    },
    //搜索分组名
    async searchGroupName() {
      this.checkGroupAll = false;
      let res = await _searchGroupName({
        groupName: this.groupName
      });
      this.list.manageDomain_group = res;
    },
    //搜索网吧名
    async searchBarName() {
      this.checkBarAll = false;
      let res = await _searchBarName({
        barName: this.barName
      });
      this.list.manageDomain_bar = res;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/msgbox/_msgBox.scss";
.registeredSubAccount {
  width: 600px;
  height: 620px;
  .content {
    display: inline-block;
    text-align: left;
    padding-left: 66px;
    padding-top: 5px;
    padding-bottom: 5px;
    .commonStyle {
      height: 30px;
      line-height: 30px;
      margin-top: 10px;
      span {
        min-width: 60px;
        display: inline-block;
        text-align: right;
        color: #a1a1a1;
      }
      input,
      select {
        border: 1px solid rgba(230, 230, 230, 1);
        padding-left: 10px;
        margin-left: 10px;
      }
      input {
        width: 300px;
        height: 30px;
      }
      select {
        outline: none;
        width: 312px;
        height: 32px;
      }
    }
    .manageAuthority,
    .manageDomain {
      margin-top: 10px;
      text-align: center;
      display: inline-block;
      overflow: hidden;
      span.title {
        float: left;
        min-width: 60px;
        display: inline-block;
        text-align: right;
        color: #a1a1a1;
        line-height: 30px;
        height: 30px;
      }
      .item {
        float: left;
        width: 310px;
        margin-left: 10px;
        overflow: hidden;
        min-height: 60px;
        ul > li {
          float: left;
          width: 50%;
          color: #515151;
          line-height: 30px;
          height: 30px;
          text-align: left;
          input {
            width: auto;
            margin-right: 3px;
            position: relative;
            top: 2px;
          }
        }
      }
    }
    .manageDomain {
      margin-top: 0;
      .content {
        float: left;
        width: 380px;
        height: 150px;
        border: 1px solid rgba(230, 230, 230, 1);
        margin-left: 10px;
        overflow: hidden;
        padding: 0;
        .search {
          width: 100%;
          height: 30px;
          line-height: 30px;
          border-bottom: 1px solid rgba(230, 230, 230, 1);
          overflow: hidden;
          .left {
            float: left;
            width: 70%;
            input {
              height: 30px;
              width: 100%;
              padding-left: 10px;
            }
          }
          .right {
            float: right;
            padding-right: 20px;
            input {
              position: relative;
              top: 2px;
              margin-right: 3px;
            }
          }
        }
        .group {
          width: 370px;
          height: 120px;
          overflow-y: auto;
          padding: 0 5px;
          background: rgba(245, 246, 250, 1);
          ul > li {
            float: left;
            height: 30px;
            line-height: 30px;
            width: 33%;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            input {
              position: relative;
              top: 2px;
              margin-right: 3px;
            }
          }
        }
      }
    }
  }
  .btn {
    padding-top: 10px;
    .left {
      height: 30px;
      width: 45%;
      margin-left: 66px;
      .wrong {
        height: 100%;
        width: 100%;
        line-height: 30px;
        text-align: left;
        color: $red;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
